// CSV tokenizing primitives, shared by the BI Admin maintenance screens' bulk imports.
//
// Hand-rolled rather than pulling in a CSV library, matching the repo's existing approach
// (react-csv is export-only). Handles quoted fields, escaped quotes ("") and commas inside
// quotes -- SiteList's Branch Name column is "Commerce, CA", so comma-splitting is not an
// option anywhere here.
//
// These are the value-level primitives only. Mapping a header row to a feature's fields
// stays in that feature, because the field list and its aliases differ per table.

/**
 * Fold a header cell to a comparable form, so a file exported from a screen and the
 * spreadsheet the team already maintains both match: case- and space-insensitive, and
 * underscores are equivalent to spaces (Market_Wage vs "Market Wage").
 */
export const canonicalize = value =>
  String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/[\s_]+/g, '');

/** Split on newlines that are not inside a quoted field. */
export const splitCsvLines = text => {
  const lines = [];
  let current = '';
  let inQuotes = false;

  for (let i = 0; i < text.length; i += 1) {
    const char = text[i];
    if (char === '"') {
      // a doubled quote inside a quoted field is an escaped quote, not a terminator
      if (inQuotes && text[i + 1] === '"') {
        current += '""';
        i += 1;
      } else {
        inQuotes = !inQuotes;
        current += char;
      }
    } else if ((char === '\n' || char === '\r') && !inQuotes) {
      if (char === '\r' && text[i + 1] === '\n') {
        i += 1;
      }
      lines.push(current);
      current = '';
    } else {
      current += char;
    }
  }
  if (current !== '') {
    lines.push(current);
  }
  return lines.filter(line => line.trim() !== '');
};

/** Split one line into cells, honouring quotes and doubled-quote escapes. */
export const parseCsvLine = line => {
  const cells = [];
  let current = '';
  let inQuotes = false;

  for (let i = 0; i < line.length; i += 1) {
    const char = line[i];
    if (char === '"') {
      if (inQuotes && line[i + 1] === '"') {
        current += '"';
        i += 1;
      } else {
        inQuotes = !inQuotes;
      }
    } else if (char === ',' && !inQuotes) {
      cells.push(current);
      current = '';
    } else {
      current += char;
    }
  }
  cells.push(current);
  return cells;
};
